import request from '@/plugins/request'

const API = {
  list: '/student/pc/practiceAssessment/list',
  uploadReport: '/student/pc/practiceAssessment/uploadReport'
}

export function getPracticeAssessmentList() {
  return request.get(API.list)
}

/**
 * 提交实践考核报告（支持视频附件）
 * @param {Object} data
 * @param {number} data.id 考核记录ID
 * @param {string} data.reportAtt 报告文件地址
 * @param {string} data.reportFileName 报告文件名
 * @param {string} [data.videoAtt] 视频文件地址，可选
 * @param {string} [data.videoName] 视频文件名，可选
 * @param {string} [data.videoSize] 视频大小，可选，纯数字字符串（单位：字节）
 * @param {boolean} [data.removeVideo] 是否删除原视频，可选
 */
export function uploadPracticeReport(data) {
  return request.post(API.uploadReport, data)
}

export function getAssessmentRequirementDetail(id) {
  return request.get(`/sjkh/assessment-requirement/detail/${id}`)
}

export function getAssessmentRequirementList(params) {
  return request.get('/sjkh/assessment-requirement/list', params)
}

export function getStudentAssessmentRequirement(recordId) {
  return request.get('/student/pc/practiceAssessment/requirement', { recordId })
}
